import src from "IMAGE";
export default { src, width: 626, height: 591, blurWidth: 0, blurHeight: 0};
